<div class="item-details">
  <div class="route-summary">
    <table aria-describedby="Table for Task Details" class="task-details">
      <tr>
        <th *ngIf="additionalData.tab !== tabName.Unplanned">Route Name</th>
        <th *ngIf="additionalData.tab !== tabName.Unplanned">Stop Sequence</th>
        <th>Task Point Name</th>
        <th>Address</th>
        <th>Postal Code</th>
        <th>Order Id</th>
        <th>Task Type</th>
        <th>Status</th>
      </tr>
      <tr>
        <td *ngIf="additionalData.tab !== tabName.Unplanned">{{additionalData.element.route_name}}</td>
        <td *ngIf="additionalData.tab !== tabName.Unplanned">{{additionalData.element.stop_sequence}}</td>
        <td>{{additionalData.element.task_point_name}}</td>
        <td>{{additionalData.element.address}}</td>
        <td>{{additionalData.element.postal_code}}</td>
        <td>{{additionalData.element.pbm_order_id}}</td>
        <td>{{additionalData.element.task_type}}</td>
        <td>{{additionalData.element.task_state}}</td>
      </tr>
    </table>
    <hr style="margin: 0px;"/>
  </div>
  <div class="itemTable mt-2">
    <p-table class="innerTable"
    scrollHeight="400px" 
    [value]="itemList" [scrollable]="true" >
      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngIf="additionalData.type === 'goods'; else itemsHeader">
            <th pSortableColumn="weight">Weight<p-sortIcon field="weight"></p-sortIcon></th>
            <th pSortableColumn="quantity">Quantity<p-sortIcon field="quantity"></p-sortIcon></th>
            <th pSortableColumn="volume">Volume<p-sortIcon field="volume"></p-sortIcon></th>
            <th pSortableColumn="goodsType">Goods Type<p-sortIcon field="goodsType"></p-sortIcon></th>
          </ng-container>
          <ng-template #itemsHeader>
            <th><i class="pi pi-flag" pTooltip="Shipment Indicators"></i> </th>
            <th pSortableColumn="consigner_name">Sender Name <p-sortIcon field="consigner_name"></p-sortIcon></th>
            <th pSortableColumn="consignee_name">Receiver Name <p-sortIcon field="consignee_name"></p-sortIcon></th>
            <th pSortableColumn="customer_number">Customer Number <p-sortIcon field="customer_number"></p-sortIcon></th>
            <th pSortableColumn="product_code">Product Code <p-sortIcon field="product_code"></p-sortIcon></th>
            <th>Barcode</th>
            <th pSortableColumn="weight">Weight <p-sortIcon field="weight"></p-sortIcon></th>
            <th pSortableColumn="volume">Volume <p-sortIcon field="volume"></p-sortIcon></th>
            <th pSortableColumn="item_state">Item State <p-sortIcon field="item_state"></p-sortIcon></th>
            <th pSortableColumn="quantity">Quantity <p-sortIcon field="quantity"></p-sortIcon></th>
            <th *ngIf="additionalData.tab == tabName.Planned.toLowerCase()">Sorting Image</th>
          </ng-template>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-element>
        <tr>
          <ng-container *ngIf="additionalData.type === 'goods'; else itemsColumns">
            <td>{{ element.weight ? element.weight/1000 : 0 }}</td>
            <td>{{ element.quantity }}</td>
            <td>{{ element?.volume }}</td>
            <td>{{ element.goodsType }}</td>
          </ng-container>
          <ng-template #itemsColumns>
            <td>
              @if(element?.is_same_day_shipment) {
                <img src="assets/image/same_day_icon.svg" 
                pTooltip="Same Day Delivery" class="align-middle label-less-icon" width="16" height="16" alt="same_day_shipment" />
              }
            </td>
            <td>{{ element?.consigner_name }}</td>
            <td>{{ element?.consignee_name }}</td>
            <td>{{ element?.customer_number }}</td>
            <td>{{ element?.product_code }}</td>
            <td>
              <a href="javascript:void(0)" (click)="barcodeClicked(element)">{{ element?.pn_item_id }}</a>
            </td>
            <td>{{ element?.weight/1000 || 0 }}</td>
            <td>{{ element?.volume }}</td>
            <td>{{ element?.item_state }}</td>
            <td>{{ element?.quantity }}</td>
            <td *ngIf="additionalData.tab == tabName.Planned.toLowerCase()" class="pointer-cursor" (click)="openImageDialog(element?.pn_item_id)"><i class="pi pi-image"></i>
          </ng-template>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>